<template>
  <div>
    <sign-in></sign-in>
    <div class="ui fixed inverted menu">
      <div id='header-menu' class="ui dropdown icon item">
        <i class="sidebar icon"></i>
        <div class="menu">
          <div class="header">Main</div>
          <router-link to="/movie-times-and-tickets" class="item">Movie Times &amp; Tickets</router-link>
          <router-link to="/movies" class="item">Movies</router-link>
          <router-link to="/tv" class="item">TV</router-link>
          <router-link to="/new-on-dvd" class="item">New On DVD</router-link>
          <router-link to="/facebook" class="item">Facebook</router-link>
          <div class="header">Support</div>
          <div class="divider"></div>
          <router-link to="/help" class="item">Help</router-link>
          <router-link to="/bpmn" class="item" target="_blank">BPMN</router-link>
        </div>
      </div>
      <router-link to="/" class="active item">Home</router-link>
      <router-link to="/videos" class="item">Videos</router-link>
      <div class="right menu">
        <div class="ui right aligned category search item">
          <div class="ui inverted transparent icon input">
            <input class="prompt" type="text" placeholder="Search keyword...">
            <i class="search link icon"></i>
          </div>
          <div class="results"></div>
        </div>
        <a class="ui item">
          Logout
        </a>
        <a class="item" v-on:click='showSingInModal'>Sing In</a>
        <a class="item" v-on:click='showSingInModal'>Sing Up</a>
      </div>
    </div>

    <div class="ui main text container">
      <router-view></router-view>
      <!--
      <div class="fb-comments" data-href="https://spinoff.cloudhomez.com/" data-numposts="5"></div>
      -->
    </div>
  </div>
</template>

<script>
  import SignIn from '../modal/SignIn'

  export default {
    name: 'app',
    components: { SignIn },
    methods: {
      showSingInModal: function() {
        window.showSingInModal()
      }
    },
    mounted () {
      window.$('#header-menu').dropdown({})
    },
    data() {
      return {
        videos: []
      }
    }
  }
</script>

<style scoped>
body {
  background-color: #FFFFFF;
}
.ui.menu .item img.logo {
  margin-right: 1.5em;
}
.main.container {
  padding-top: 4rem;
}
.ui.footer.segment {
  margin: 5em 0em 0em;
  padding: 1.5em 0em;
}
.ui.text.container {
  max-width: 1200px !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?69c94dca